<template>
  <v-card class="pa-4">
    <label class="label">Status wniosku:</label>
    <div class="mt-2">
      <AppStatus
        :status-text="request.status"
        multiline
      />
    </div>
    <v-stepper
      :value="request.progressStep"
      alt-labels
      elevation="0"
      class="dko-status-card__stepper"
    >
      <v-stepper-header>
        <template v-for="(step, index) in steps">
          <v-tooltip
            :key="step.number"
            bottom
          >
            <template #activator="{ on, attrs }">
              <v-stepper-step
                v-bind="attrs"
                :step="step.number"
                :complete="request.progressStep > step.number || request.progressStep === 4"
                :color="stepColor"
                v-on="lastStatus(step.number) ? on : {}"
              >
                {{ step.label }}
              </v-stepper-step>
            </template>
            {{ lastStatus(step.number) }}
          </v-tooltip>
          <v-divider
            v-if="index < steps.length - 1"
            :key="`divider-${step.number}`"
          />
        </template>
      </v-stepper-header>
    </v-stepper>
    <p
      v-if="needsTeam"
      class="mb-0 text-body-2"
    >
      Akceptacja briefu pojawi się po dodaniu co najmniej jednej osoby do zespołu projektowego.
    </p>
    <p
      v-if="request.kiwNumberAssignment && request.progressStep === 3"
      class="mb-0 mt-2 text-body-2"
    >
      Wniosek ma zaznaczone nadanie numeru KIW. „Zatwierdź i zarchiwizuj” utworzy wniosek KIW i zamknie tę ścieżkę.
    </p>
  </v-card>
</template>

<script>
import AppStatus from '@/components/UI/AppStatus.vue';

const BRIEF_STATUS = 'Brief do akceptacji Dyrekcji DKO';

export default {
  components: { AppStatus },
  props: {
    request: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      steps: [
        { number: 1, label: 'Brief' },
        { number: 2, label: 'Ocena treści' },
        { number: 3, label: 'Rekomendacja' },
        { number: 4, label: 'Zakończenie' },
      ],
    };
  },
  computed: {
    needsTeam() {
      return this.request.status === BRIEF_STATUS && !this.request.members.length;
    },
    stepColor() {
      if (this.request.status.toLowerCase().includes('odrzu')) return '#E25B46';
      if (this.request.progressStep === 4) return '#00695F';
      return 'primary';
    },
  },
  methods: {
    lastStatus(step) {
      return this.request.lastStatusPerStep?.find((entry) => entry.lastNumber === step)?.last;
    },
  },
};
</script>

<style lang="scss" scoped>
.dko-status-card__stepper {
  margin: 8px 0 0;
}
</style>
